export default () => <span className="components-spinner" />;
